import { Component, OnInit } from '@angular/core';
import { CategoriasService } from '../../services/categorias.service';
import { PlatillosService } from '../../services/platillos.service';
import { map } from 'rxjs/operators';
import { AuthService } from '../../admin/auth.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CodesService } from '../../services/extras/codes.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  public user$: Observable <any> = this._auth._authfb.user;
  detailUser;

  ds_categorias;
  filtro_platillos;

  verPrecios;
  ds_menu;

  param_code;

  public showMenu = false;

  constructor(
    private _categorias: CategoriasService,
    private _platillos: PlatillosService,
    private _auth: AuthService,
    private route: ActivatedRoute,
    private _codes: CodesService
  ) { }

  ngOnInit(): void {
    Swal.fire({
      title: "Cargando información...",
      text: "Espere por favor.",
      icon: "info"
    })

    Swal.showLoading();

    this.verPrecios = false;
    this.setDetailUser();
    this.showMenu = false;
    this.consultarCategorias();
    this.consultarPlatillos();
    this.detectParams();
  }

  setDetailUser(){
    this.user$.subscribe( async data => {
      if(data?.email){
        this.detailUser = await data;
      }else{
        this.detailUser = null;
      }
    });
  }

  detectParams(){

    let code = null;
    this.route.params.subscribe( data => {
      if(data){
        code = data.code;
      }
      this.buscarCode(code);
    });

  }

  async buscarCode(code: string = 'directo'){

    this.param_code = await new Promise((resolve, reject) => {
      try {
        this._codes.getCode(code).subscribe( data => {
          if(data.payload.data()){
            resolve(data.payload.data())
          }else{
            resolve(code)
          }
        })
      } catch (error) {
        return;
      }
    })
    let updateCode = { uid: "", visitas: {} };
    // Registro visita
    if(this.param_code)  {
      updateCode = this.param_code;
      updateCode.uid = code
      this.verPrecios = true;
    }
    else{
      this.verPrecios = false;
      updateCode.uid = code;
    }

    let nuevaVisita = {
      num: (this.param_code.visitas)? this.param_code.visitas.num + 1 : 1,
      ultima_visita: new Date()
    }
    updateCode.visitas = nuevaVisita;

    try {
      //this.analytics.logEvent('visita');
      this._codes.edit(updateCode, updateCode.uid);

    } catch (error) {

    }

  }

  volverArriba(){
    window.scroll({
      top: +100,
      left: 100,
      behavior: 'smooth'
    });
  }

  btnShowCategorias(){
    this.showMenu = !this.showMenu;
    window.scroll({
      top: +100,
      left: 100,
      behavior: 'smooth'
    });
  }

  consultarCategorias(){
    this._categorias.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
        )
      )
    ).subscribe( categorias => {
      this.ds_categorias = categorias;
    })
  }

  consultarPlatillos(){
    this._platillos.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({
            uid: d.payload.doc.id,
            ...d.payload.doc.data()
          })
        )
      )
    ).subscribe( platillos => {
      this.ds_menu = platillos;
      this.filtro_platillos = this.ds_menu;
    })
  }

  selectCategory(cat:string ='all'){

    if(cat == "all"){
      this.filtro_platillos = this.ds_menu;
    }
    else{
      this.filtro_platillos = this.ds_menu.filter( res => res.category.uid == cat);
    }

    window.scroll({
      top: +400,
      left: 100,
      behavior: 'smooth'
    });

  }

  getNameCategory(uid: string){
    return this.ds_categorias.find( res => res.uid == uid)['categoria'];
  }


}
